import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75374ac7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-items" }
const _hoisted_2 = { class: "nav-items__list" }
const _hoisted_3 = { class: "nav-items__list-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/projects" }, {
          default: _withCtx(() => [
            _createTextVNode("Портфолио")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", {
        class: "nav-items__list-item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToBlock('contacts')))
      }, " Контакты "),
      (_ctx.showFaq)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "nav-items__list-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToBlock('faq')))
          }, " Частые вопросы "))
        : _createCommentVNode("", true)
    ])
  ]))
}